import { render, staticRenderFns } from "./TweakwiseLoader.vue?vue&type=template&id=683ed080&scoped=true&"
import script from "./TweakwiseLoader.vue?vue&type=script&lang=ts&"
export * from "./TweakwiseLoader.vue?vue&type=script&lang=ts&"
import style0 from "./TweakwiseLoader.vue?vue&type=style&index=0&id=683ed080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ed080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683ed080')) {
      api.createRecord('683ed080', component.options)
    } else {
      api.reload('683ed080', component.options)
    }
    module.hot.accept("./TweakwiseLoader.vue?vue&type=template&id=683ed080&scoped=true&", function () {
      api.rerender('683ed080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/TweakwiseLoader.vue"
export default component.exports